/* eslint-disable comma-dangle */
/* eslint-disable import/prefer-default-export */
import CA from '../assets/icons/Canada (CA).svg';
import { ReactComponent as business } from '../assets/icons/Core/business.svg';
import { ReactComponent as custom } from '../assets/icons/Core/custom.svg';
import { ReactComponent as MobileApps } from '../assets/icons/Core/mobileApps.svg';
import { ReactComponent as qa } from '../assets/icons/Core/qa.svg';
import { ReactComponent as seo } from '../assets/icons/Core/seo.svg';
import { ReactComponent as uiUx } from '../assets/icons/Core/UI.svg';
import fb from '../assets/icons/fb.svg';
import IN from '../assets/icons/India (IN).svg';
import insta from '../assets/icons/insta.svg';
import linked from '../assets/icons/linkedin.svg';
import USA from '../assets/icons/United States of America (US).svg';
import twitter from '../assets/icons/xtwitter.svg';
import youtube from '../assets/icons/youtube.svg';
import contact1 from '../assets/images/contact-1.svg';
import contact2 from '../assets/images/contact-2.svg';
import contact3 from '../assets/images/contact-3.svg';
import education from '../assets/images/Education.svg';
import fitness from '../assets/images/hero-bg-1.svg';
import product from '../assets/images/hero-bg-2.svg';
import healthcare from '../assets/images/hero-fr-1.svg';
import realEstate from '../assets/images/hero-fr-2.svg';
import agam from '../assets/images/women/agam.png';
import anishi from '../assets/images/women/Anishi.png';
import baljinder from '../assets/images/women/Baljinder.png';
import deepa from '../assets/images/women/Deepa.png';
import deepika from '../assets/images/women/deepika.png';
import dhanvir from '../assets/images/women/dhanvir.png';
import gurbinder from '../assets/images/women/gurbinder.png';
import maduri from '../assets/images/women/madhuri.png';
import nehabehl from '../assets/images/women/neha-behl.png';
import neha from '../assets/images/women/neha.png';
import nehamam from '../assets/images/women/Nehamam.png';
import parul from '../assets/images/women/parul.png';
import satnam from '../assets/images/women/satnam.png';
import shalini from '../assets/images/women/shalini.png';
import shikha from '../assets/images/women/Shikha-5.png';
import shruti from '../assets/images/women/shruti.png';
import sonam from '../assets/images/women/sonam.png';
import swati from '../assets/images/women/swati.png';
import vaishnavi from '../assets/images/women/Vaishnavi.png';
import vasvi from '../assets/images/women/vasvi.png';

const coreServices = [
  {
    icon: MobileApps,
    title: 'Web and Mobile apps',
    text: 'Taking your Business to Professionally Intelligent, Technically Innovative, and Beautifully Designed Websites.',
    href: 'https://thesynergyworks.com/',
  },
  {
    icon: uiUx,
    href: 'https://thesynergyworks.com/',
    title: 'Branding and UI/UX',
    text: 'We design web & app wireframes, mockups, UI/UX & PSD, any graphic material, and any corporate identity.',
  },
  {
    icon: seo,
    href: 'https://thesynergyworks.com/',
    title: 'SEO & Digital Marketing',
    text: 'Think Digital & Get High Visibility Online. We help drive traffic and grow brand awareness for your business online.',
  },
  {
    icon: custom,
    href: 'https://thesynergyworks.com/',
    title: 'Custom Development',
    text: 'With our extensive experience and innovative ideas within various technology stacks, We develop custom solutions for our client.',
  },
  {
    icon: qa,
    href: 'https://thesynergyworks.com/',
    title: 'Quality Assurance',
    text: 'We deliver bug-free, high quality and cost effective web and mobile app services.',
  },
  {
    icon: business,
    href: 'https://thesynergyworks.com/',
    title: 'Business Analysis',
    text: 'We help companies by analysing their business and provide them cost effective solutions',
  },
];

const industries = [
  {
    title: 'HealthCare',
    img: healthcare,
    href: 'https://thesynergyworks.com/',

  },
  {
    title: 'Real Estate',
    img: realEstate,
    href: 'https://thesynergyworks.com/',

  },
  {
    title: 'Fitness',
    img: fitness,
    href: 'https://thesynergyworks.com/',

  },
  {
    title: 'Education',
    img: education,
    href: 'https://thesynergyworks.com/',

  },
  {
    title: 'Finance',
    href: 'https://thesynergyworks.com/',
    img: product,
  },
];

const footerLinks = {
  about: [
    {
      title: 'Our Company',
      to: '#who',
      target: 'self',
    },
    {
      title: 'How we work',
      to: '#design',
      target: 'self',
    },
    {
      title: 'Portfolio',
      to: 'https://www.behance.net/synergyworksllp',
      target: 'self',

    },
    {
      title: 'Careers',
      to: 'https://thesynergyworks.com/hiring/',
      target: 'self',

    },
    {
      title: "CEO's Desk",
      to: 'https://thesynergyworks.com/ceo-shikha-taman/',
      target: 'self',
    },
  ],

  services: [
    {
      title: 'Android App Development',
      to: 'https://thesynergyworks.com/expertise/android-app-development-company/',
      target: 'self',

    },
    {
      title: 'Bespoke Software Development',
      to: 'https://thesynergyworks.com/expertise/bespoke-software-development-company/',
      target: 'self',

    },
    {
      title: 'Enterprise Software Development',
      to: 'https://thesynergyworks.com/expertise/enterprise-software-development-company/',
      target: 'self',

    },
    {
      title: 'iPhone Application Development',
      to: 'https://thesynergyworks.com/expertise/iphone-application-development-company/',
      target: 'self',

    },
    {
      title: 'React Native App Development',
      to: 'https://thesynergyworks.com/expertise/react-native-app-development-company/',
      target: 'self',

    },
    {
      title: 'Uber like App Development',
      to: 'https://thesynergyworks.com/expertise/uber-like-app-development/',
      target: 'self',

    },
    {
      title: 'Startup App Development',
      to: 'https://thesynergyworks.com/expertise/startup-app-development-company/',
      target: 'self',

    },
    {
      title: 'Flutter App Development',
      to: 'https://thesynergyworks.com/expertise/flutter-app-development/',
      target: 'self',

    },
    {
      title: 'Pharmacy App Development',
      to: 'https://thesynergyworks.com/expertise/pharmacy-app-development/',
      target: 'self',

    },
    {
      title: 'Privacy Policy',
      to: 'https://thesynergyworks.com/privacy-policy/',
      target: 'self',

    },
  ],
  talkToUs: [
    {
      title: '+91 84273-33204 (IN)',
      to: 'tel:+918427333204',
    },
    // {
    //   title: '+1 305 206 3355 (USA)',
    //   to: 'tel:+13052063355',
    // },
    {
      title: '+1 778 325 9876 (CA)',
      to: 'tel:+17783259876',
    },

  ],
  locations: [
    {
      title: 'India',
      icon: IN,
    },
    {
      title: 'USA',
      icon: USA,
    },
    {
      title: 'Canada',
      icon: CA,
    },
  ],
};

const socialLinks = [
  {
    title: 'FB',
    name: 'Facebook',
    to: 'https://www.facebook.com/thesynergyworks/',
    logo: fb,
  },
  {
    title: 'IG',
    name: 'Instagram',
    to: 'https://www.instagram.com/thesynergyworks/',
    logo: insta,
  },
  {
    title: 'LI',
    name: 'LinkedIn',
    to: 'https://www.linkedin.com/company/thesynergyworks/',
    logo: linked,
  },
  {
    title: 'YT',
    name: 'YouTube',
    to: 'https://www.youtube.com/channel/UCkD9_GoYOF0pTPN2-DVEeNQ',
    logo: youtube,
  },
  {
    title: 'TW',
    name: 'Twitter',
    to: 'https://twitter.com/thesynergyworks',
    logo: twitter,
  },
];

const navLinks = [
  {
    title: 'Services',
    to: 'https://thesynergyworks.com/core-services/',
    target: 'self',
  },
  // {
  //   title: 'Expertise',
  //   to: 'https://thesynergyworks.com/expertise',
  //   target: 'self',
  // },
  {
    title: 'Portfolio',
    to: 'https://www.behance.net/synergyworksllp',
    target: 'self',

  },
  {
    title: 'Products',
    to: 'https://thesynergyworks.com/products/',
    target: 'self',

  },
  {
    title: 'Team',
    to: 'https://thesynergyworks.com/team',
    target: 'self',

  },
  {
    title: 'Blogs',
    to: 'https://thesynergyworks.com/blog/',
    target: 'self',

  },
  {
    title: 'We Are Hiring',
    to: 'https://thesynergyworks.com/hiring',
    target: 'self',

  },
  {
    title: "CEO's Desk",
    to: 'https://thesynergyworks.com/ceo-shikha-taman',
    target: 'self',

  },
  {
    title: 'Life At Synergyworks',
    to: 'https://thesynergyworks.com/life-at-synergyworks/',
    target: 'self',

  },
];

const contactImages = [
  contact1,
  contact2,
  contact3,
  contact1,
];

const womenDay = [

  {
    firstName: 'Shikha',
    lastName: 'Taman',
    profile: ['Founder', 'CEO'],
    bg: '#FF6F42',
    profilePic: shikha,
    scale: '1',
  },
  {
    firstName: 'Shalini',
    lastName: 'Taman',
    profile: ['Head Marketing', 'Head Sales'],
    bg: '#00B0FA',
    profilePic: shalini,
    scale: '0.7',
  },
  {
    firstName: 'Gurbinder',
    lastName: 'Ahuja',
    profile: ['Sr. Quality Analyst'],
    bg: '#56FF8F',
    profilePic: gurbinder,
    scale: '0.7',
  },
  {
    firstName: 'Vasvi',
    lastName: 'Sood',
    profile: ['Project Cordinator', 'Sr. Quality Analyst'],
    bg: '#FFD056',
    profilePic: vasvi,
    scale: '0.7',
  },
  {
    firstName: 'Neha',
    lastName: 'Behl',
    profile: ['HR executive'],
    bg: '#EF8DFF',
    profilePic: nehabehl,
    scale: '0.7',
  },
  {
    firstName: 'Neha',
    lastName: 'Murria',
    profile: ['Sr. Nodejs developer'],
    bg: '#56FF8F',
    profilePic: neha,
    scale: '0.7',
  },
  {
    firstName: 'Satnam',
    lastName: 'Kaur',
    profile: ['Sr. Angular Developer', 'Module Lead'],
    bg: '#00B0FA',
    profilePic: satnam,
    scale: '0.7',
  },
  {
    firstName: 'Sonam',
    lastName: 'Tomar',
    profile: ['Project Manager'],
    bg: '#FF6F42',
    profilePic: sonam,
    scale: '0.7',
  },
  {
    firstName: 'Maduri',
    lastName: 'Kumari',
    profile: ['Angular Developer'],
    bg: '#FFD056',
    profilePic: maduri,
    scale: '0.7',
  },
  {
    firstName: 'Deepika',
    lastName: 'Sharma',
    profile: ['Quality Analyst'],
    bg: '#336980',
    profilePic: deepika,
    scale: '0.7',
  },
  {
    firstName: 'Shruti',
    lastName: 'Pandiya',
    profile: ['Wordpress Developer'],
    bg: '#D05252',
    profilePic: shruti,
    scale: '0.7',
  },
  {
    firstName: 'Anishi',
    lastName: 'Jain',
    profile: ['UI/UX Graphics Designer'],
    bg: '#FFD056',
    profilePic: anishi,
    scale: '0.7',
  },
  {
    firstName: 'Deepa',
    lastName: 'Kaw',
    profile: ['Medical Assistant Executive'],
    bg: '#EF8DFF',
    profilePic: deepa,
    scale: '0.7',
  },
  {
    firstName: 'Neha',
    lastName: 'Pathania',
    profile: ['Sr. HR Executive'],
    bg: '#52D0C9',
    profilePic: nehamam,
    scale: '0.7',
  },
  {
    firstName: 'Baljinder',
    lastName: 'kaur',
    profile: ['Wordpress Developer'],
    bg: '#00B0FA',
    profilePic: baljinder,
    scale: '0.7',
  },
  {
    firstName: 'Parul',
    lastName: 'Verma',
    profile: ['HR Executive'],
    bg: '#FF6F42',
    profilePic: parul,
    scale: '0.7',
  },
  {
    firstName: 'Vaishnavi',
    lastName: 'Mohadikar',
    profile: ['Reactjs Developer'],
    bg: '#00B0FA',
    profilePic: vaishnavi,
    scale: '0.7',
  },
  {
    firstName: 'Balvinder',
    lastName: 'Sahni',
    profile: ['Business Analyst'],
    bg: '#D05252',
    profilePic: agam,
    scale: '0.7',
  },
  {
    firstName: 'Dhanvir',
    lastName: 'Kaur',
    profile: ['Project Manager'],
    bg: '#52D0C9',
    profilePic: dhanvir,
    scale: '0.7',
  },
  {
    firstName: 'Swati',
    lastName: 'Gupta',
    profile: ['Nodejs Developer'],
    bg: '#FF6F42',
    profilePic: swati,
    scale: '0.7',
  },

];

export {
  contactImages, coreServices, footerLinks, industries, navLinks, socialLinks, womenDay
};
